import React from "react";
import moment from 'moment';
import { component_tool } from "@/tool";
import { WizClassifySelect } from '@/containers/common';
import HighSet from "@/containers/common/highSet";
let { WizModal } = component_tool;
//配置项
let componentName = 'offlineProgramManagement';
let ref;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
};
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "课程名称",
    name: "searchName",
    searchItem: {}
  },
  {
    title: "课程名称",
    name: "name",
    tableItem: {
      width: 200,
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入名称',
      }, {
        max: 25,
        message: '名称长度不能超过25个字符'
      }],
      placeholder: "请输入"
    }
  },
  {
    title: "课程编码",
    name: "searchCode",
    searchItem: {}
  },
  {
    title: "课程编码",
    name: "code",
    tableItem: {
      width: 200,
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入名称',
      }, {
        max: 64,
        message: '名称长度不能超过64个字符'
      }],
      placeholder: "请输入"
    }
  },
  {
    title: "分类",
    name: "typeList",
    dict: [],
    searchItem: {
      type: 'diy',
      diy: WizClassifySelect,
      returnKey: true,
      wizTreeSelectListProps: {
        itemProps: {
          icon: 'unordered-list',
          title: '培训分类',
          tips: '请勾选培训分类'
        },
        treeProps: { checkStrictly: true }
      },
      apiProps: { type: 1 },
      selectProps: {
        placeholder: '请选择培训分类'
      },

    }
  },

  {
    title: "分类",
    name: "categoryNames",
    tableItem: {
      width: 300,
    }
  },
  // {
  //   title: "类别",
  //   name: "category",
  //   dict: [
  //     { code: 0, codeName: "普通课程" },
  //     { code: 1, codeName: "新能源课程" },
  //   ],
  //   tableItem: {
  //   },
  //   searchItem: {
  //     type: "select"
  //   },
  // },
  {
    title: '结束日期',
    name: 'endDate',
    dataIndex: "endDate",
    tableItem: {
      width: 150,
      render: text => {
        return formatterDate(text)
      }
    },
    formItem: {
      type: 'date'
    },
  },
  {
    title: "状态",
    name: "status",
    dict: [
      { code: 0, codeName: "草稿" },
      { code: 1, codeName: "发布" },
      { code: 2, codeName: "关闭" }
    ],
    tableItem: {
    },
    searchItem: {
      type: "select"
    },
    formItem: {
      type: "radio"
    }
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 12,
          md: 12,
          xl: 12
        },
        // dataFormat:(v)=>{
        //   let _v = v;
        //   if (v && v['typeList'] && v['typeList'].length) {
        //     _v.typeList = v.typeList.map(select=>select.key);//获取对应分类的id
        //   }else{
        //     _v.typeList = [];
        //   }
        //   return _v
        // },

        buttonSort: ['add', 'export'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/face/offlineProgramList/offlineProgramDetailAdd'
              }
            }
          },
          {
            key: "export",
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export' },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {
        key: "modal123",
        params: {
          modalParams: {
            title: "Modal",
            children: "Bla bla123 .."
          }
        }
      },
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false,
      },
      rowOperateSort: ['look', 'update', 'enable', 'programHelper','advancedSet'],
      rowOperateView: [
        {
          key: "enable",
          custom: true,
          params: { children: "发布"},
          textFormat: {
            recordKey: 'status',
            dirt: { 0: '发布', 2: '发布', 1: '关闭' }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateOfflineProgramStatus",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              let statusNameStr = record['status'] === 0 || record['status'] === 2 ? "发布" : "关闭";
              const content = `您确定要` + statusNameStr + `该培训课程？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    status: record['status'] === 0 || record['status'] === 2 ? 1 : 2,
                    idList: [record['id']]
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/face/offlineProgramList/offlineProgramDetailUpd"
            }
          }
        },
        {
          key: 'advancedSet',
          custom: true,
          params: {children: '高级设置'},
          customOnClick: {
            key: 'modal',
            params: {
              modalParams: {
                title: '高级设置',
                bordered: true,
                footer: null,
                destroyOnClose: true,
                diy: (e) => {
                  //BIZ_APPLY = 15;
                  return <>
                    <HighSet data={{record: e.record, bizType: 8}}
                             changeModal={e.changeModal}
                    />
                  </>
                },
                width: 950
              },
            }
          },
        },
        /*{
          key: "programHelper",
          custom: true,
          params: { children: "课程助手" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/face/offlineProgramList/offlineProgramDetailUpd"
            }
          }
        }*/
      ],
      commonOperate: {
        add: true,
        delete: false,
        update: true,
        look: true

      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@getListByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  updateOfflineProgramStatus: {
    path: `${componentName}/updateOfflineProgramStatus`,
    payload: {
      key: `${componentName}@updateOfflineProgramStatus`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
